/* eslint-disable import/no-anonymous-default-export */
export default (state = '', action) => {
  if (action.type === 'SET_VT_CONTAINER') {
    return action.payload;
  }

  return state;
}